import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

export const SurToggleOrdersFilter: Handler = (props: any) => {
    props.dispatch({
        type: "Pages/SurOrderHistory/SurToggleFiltersOpen",
    });
};

export const chain = [SurToggleOrdersFilter];

const surtoggleFiltersOpen = createHandlerChainRunnerOptionalParameter(chain, {}, "SurtoggleFiltersOpen");
export default surtoggleFiltersOpen;
